import { render } from "./OverviewCard.vue?vue&type=template&id=ed155ecc&scoped=true"
import script from "./OverviewCard.vue?vue&type=script&lang=js"
export * from "./OverviewCard.vue?vue&type=script&lang=js"

import "./OverviewCard.vue?vue&type=style&index=0&id=ed155ecc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed155ecc"]])

export default __exports__